import sendMarriedDoc from '../../../../api/creditPlatform/sendMarriedDoc';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import UploadProgressBar from '../../../../components/UploadProgressBar';
import useDocumentUpload from '../../../../hooks/useDocumentUpload';
import {
  DOCUMENT_TYPES_CUSTOMS_CLEARANCE_CONFIRMATION,
  DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
} from '../../../../constants';
import alert from '../../../../helpers/alert';
import onlineVehicleRegistration from '../../../../api/bank/online-vehicle-registration';

const UploadAdditionalDocuments = ({
  backHandler,
  loading,
  deal,
  chosenBankAppealId,
  setLoading,
  onSuccess,
  bankId,
}) => {
  const { uploadMultiple, uploading, progress, currentFileName, uploadQueue } = useDocumentUpload();

  const onNotarialDocumentsSubmit = async (values) => {
    // if (!values['customsClearanceConfirmation']) {
    //   alert.error('Необходимо загрузить документ подтверждающий прохождение таможенного оформления');
    //   return;
    // }

    if (!values['extendedProducerResponsibilityConfirmation']) {
      alert.error(
        'Необходимо загрузить документ подтверждающий исполнение расширенных обязательств производителями (импортерами)'
      );
      return;
    }

    const filesToUpload = [
      values['customsClearanceConfirmation'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_CUSTOMS_CLEARANCE_CONFIRMATION,
        file: values['customsClearanceConfirmation'],
      },
      values['extendedProducerResponsibilityConfirmation'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
        file: values['extendedProducerResponsibilityConfirmation'],
      },
    ].filter(Boolean);

    try {
      await uploadMultiple(filesToUpload);
      setLoading(true);

      onlineVehicleRegistration(deal?.chunkId)
        .then(() => {
          onSuccess(values);
        })
        .catch(() => {
          alert.error('Ошибка отправки документов (online-vehicle-registration)');
          setLoading(false);
        });
    } catch (err) {
      alert.error('Ошибка загрузки документов');
      setLoading(false);
    }
  };

  if (uploading) {
    return <UploadProgressBar progress={progress} fileName={currentFileName} queue={uploadQueue} />;
  }

  return (
    <div>
      <HookForm
        title={'Документы'}
        hint="Документы необходимые при первичной регистрации авто"
        grid={{ display: 'grid', gap: 20 }}
        action={'Сохранить и продолжить'}
        inputs={[
          {
            text: 'Документ подтверждающий исполнение расширенных обязательств производителями (импортерами)',
            label: 'Загрузить документ',
            name: 'extendedProducerResponsibilityConfirmation',
            id: 'Документ подтверждающий исполнение расширенных обязательств производителями (импортерами)',
            component: DocsInputNew,
          },
          {
            text: 'Документ подтверждающий прохождение таможенного оформления',
            label: 'Загрузить документ',
            name: 'customsClearanceConfirmation',
            id: 'Документ подтверждающий прохождение таможенного оформления',
            component: DocsInputNew,
          },
        ]}
        onSubmit={onNotarialDocumentsSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default UploadAdditionalDocuments;
